export default __webpack_public_path__ + "static/media/10.17.24 Minutes of the Regular Meeting of the BOD.854c02f7.pdf";